module.exports = __webpack_public_path__ + "static/media/10import-24.263e04d4.xlsx";